export const initialState = {
   nameQuestionary: '',
   desQuestionary: '',
   idQues: '',
   questionaries: {},
   questions: [],
   publishState: null,
   view: null,
   dataSubdomain: null,
   codeSubdomain: null,
   videoSelected: null,
   videoSave: null,
   signedVideo: null,
   questSummary: {}
}

const PUBLISH_STATE = 'PublishQuest'
const SET_QUEST_SUMMARY_ACTION = 'setSummaryAction'

export const publishQuestAction = payload => ({
   type: PUBLISH_STATE,
   payload
})

export const setQuestSummaryAction = payload => ({
   type: SET_QUEST_SUMMARY_ACTION,
   payload
})

const QuestionariesReducer = (state = initialState, action) => {
   switch (action.type) {
      case 'reset':
         return {}
      case 'signedVideoAction':
         return {
            ...state,
            signedVideo: action?.signedVideo
         }
      case 'videoSaveAction':
         return {
            ...state,
            videoSave: action?.videoSave
         }
      case 'videoSelectedAction':
         return {
            ...state,
            videoSelected: action?.videoSelected
         }
      case 'dataAplication':
         return {
            ...state,
            dataAplication: action?.dataAplication
         }
      case 'mutualWorld':
         return {
            ...state,
            view: action.view,
            dataSubdomain: action?.dataSubdomain,
            codeSubdomain: action.codeSubdomain
         }
      case 'SaveQuest':
         return {
            ...state,
            questionaries: action.questionaries,
            questions: action?.questions || []
         }
      case 'SaveQuestion':
         return {
            ...state,
            questions: action?.questions,
            idQues: action.id
         }
      case 'saveNameDes':
         return {
            nameQuestionary: action.name,
            desQuestionary: action.des
         }
      case PUBLISH_STATE:
         return { ...state, publishState: action.payload }
      case SET_QUEST_SUMMARY_ACTION:
         return { ...state, questSummary: action.payload }
      default:
         return state
   }
}

export default QuestionariesReducer
